export default "__VITE_ASSET__DM9jWEz6__"